//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import { mapState } from 'vuex'
import { Toast } from 'mint-ui'
export default {
  name: 'user-info-page',
  data() {
    return {
      hospitals: [],
      form: {
        nickname: '',
        hospitalId: '',
        mobile: '',
        email: '',
        city: ''
      },
    }
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted: function () {
    this.form = Object.assign({}, this.form, this.user)
    this.form.sex = this.form.sex !== 1 ? 'female' : 'male'
    console.log(this.form)
    this.getHospital()
  },
  methods: {
    getHospital () {
      this.$store.httpDispatch({})('getHospitalsName').then((res) => {
        const { code, data } = res.data
        if (code === 0) {
          this.hospitals = data.hospitals
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    submit () {
      const body = Object.assign({}, this.form)
      if (!this.form.mobile) {
        return Toast({
          message: '請填寫手機號',
          duration: 3000
        })
      }
      if (!this.form.nickname) {
        return Toast({
          message: '請填寫用戶名',
          duration: 3000
        })
      }
      if (!this.form.hospitalId) {
        return Toast({
          message: '請選擇所屬渠道',
          duration: 3000
        })
      }
      if (!this.form.city) {
        return Toast({
          message: '請填寫城市',
          duration: 3000
        })
      }
      this.$store.httpDispatch({})('updateDoctorInfo', body).then((res) => {
        const { code } = res.data
        if (code === 0) {
          this.$store.httpDispatch({})('getUserInfo').then((res) => {
            console.log(res)
            let { code, data } = res.data
            if (code === 0) {
              this.$store.dispatch('setUser', { user: data.user })
              this.$router.push('/doctor')
              return Toast({
                message: '修改成功',
                duration: 3000
              })
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      }).catch((err) => {
        console.log(err.data)
        return Toast({
          message: err.data.msg,
          duration: 3000
        })
      })
    }
  }
}
